import { render, staticRenderFns } from "./gCopyRight.vue?vue&type=template&id=691db000&scoped=true&"
import script from "./gCopyRight.vue?vue&type=script&lang=js&"
export * from "./gCopyRight.vue?vue&type=script&lang=js&"
import style0 from "./gCopyRight.vue?vue&type=style&index=0&id=691db000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691db000",
  null
  
)

export default component.exports